"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLimit = _getLimit;
exports.hasMetOrExceeded = _hasMetOrExceeded;
exports.default = void 0;

var _BaseContainer = _interopRequireDefault(require("./BaseContainer"));

var LimitsContainer = _BaseContainer.default.create();

function _getLimit(limit) {
  var limits = LimitsContainer.getContainer().get();
  return limits && limits[limit] != null ? limits[limit] : Infinity;
}

function _hasMetOrExceeded(value, name) {
  return value >= _getLimit(name);
}

var _default = Object.assign(LimitsContainer, {
  get: function get() {
    throw new Error('LimitsContainer.get() is no longer supported. Use LimitsContainer.getContainer().get() instead.');
  },
  getLimit: function getLimit(limit) {
    return _getLimit(limit);
  },
  hasMetOrExceeded: function hasMetOrExceeded(value, name) {
    return _hasMetOrExceeded(value, name);
  }
});

exports.default = _default;